/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CohortTypeEnum } from '../models/cohort-type-enum';
import { InsightBucketEnum } from '../models/insight-bucket-enum';
import { InsightDto } from '../models/insight-dto';
import { InsightIdEnum } from '../models/insight-id-enum';
import { TechStackDto } from '../models/tech-stack-dto';

@Injectable({
  providedIn: 'root',
})
export class InsightsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getInsightsByTechStack
   */
  static readonly GetInsightsByTechStackPath = '/insights';

  /**
   * Get Insights by Tech Stack.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInsightsByTechStack()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getInsightsByTechStack$Response(params: {
    cohort: CohortTypeEnum;
    bucket?: Array<InsightBucketEnum>;
    insightId?: Array<InsightIdEnum>;
    body?: TechStackDto
  }): Observable<StrictHttpResponse<Array<InsightDto>>> {

    const rb = new RequestBuilder(this.rootUrl, InsightsService.GetInsightsByTechStackPath, 'post');
    if (params) {
      rb.query('cohort', params.cohort, {});
      rb.query('bucket', params.bucket, {});
      rb.query('insightId', params.insightId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<InsightDto>>;
      })
    );
  }

  /**
   * Get Insights by Tech Stack.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInsightsByTechStack$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getInsightsByTechStack(params: {
    cohort: CohortTypeEnum;
    bucket?: Array<InsightBucketEnum>;
    insightId?: Array<InsightIdEnum>;
    body?: TechStackDto
  }): Observable<Array<InsightDto>> {

    return this.getInsightsByTechStack$Response(params).pipe(
      map((r: StrictHttpResponse<Array<InsightDto>>) => r.body as Array<InsightDto>)
    );
  }

}
